import React from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Paper,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

const formatValue = (val, prefix = "") => {
  return isNaN(val) || val === null || val === undefined
    ? "NA"
    : `${prefix}${val.toFixed(2)}`;
};
const PurchasedStocks = ({purchased}) => {
 

  if (purchased.length === 0) {
    return (
      <Box mt={3} sx={{ width: "100%" }}>
        <Paper
          sx={{
            p: 3,
            minWidth: "1368px",
            minHeight: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography>No stocks purchased yet.</Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box mt={3} sx={{ width: "100%" }}>
      <TableContainer
        component={Paper}
        sx={{
          mt: 3,
          borderRadius: 2,
          boxShadow: 3,
          width: "100%",
          minWidth: "1368px",
          overflowX: "auto",
        }}
      >
        <Table size="small">
          <TableHead sx={{ backgroundColor: "#2d4890" }}>
            <TableRow>
              <TableCell sx={{ color: "white", fontWeight: 600 }}>
                Symbol
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: 600 }}>
                Quantity
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: 600 }}>
                Total ₹
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: 600 }}>
                Price
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: 600 }}>
                Order Type
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: 600 }}>
                Trade ID
              </TableCell>
               <TableCell sx={{ color: "white", fontWeight: 600 }}>
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {purchased.map((stock) => (
              <TableRow key={stock.symbol} sx={{ backgroundColor: "#d4edda" }}>
                <TableCell>{stock.symbol}</TableCell>
                <TableCell>{stock.quantity}</TableCell>
                <TableCell>₹{formatValue(stock.price * stock.quantity)}</TableCell>
                <TableCell>₹{formatValue(stock.price)}</TableCell>
                <TableCell>{stock.orderType}</TableCell>
                <TableCell>{stock.tradeId}</TableCell>
                 <TableCell>{stock.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PurchasedStocks;
